import React, { Component, Fragment } from 'react';

import { Button } from 'react-bootstrap';

import { BrowserRouter } from 'react-router-dom';

import AppRoute from './route/AppRoute';

class App extends Component {
  state = {
    count: 0,
  };

  increase = () => {
    this.setState({ count: this.state.count + 2 });
  };

  render() {
    return (
      <Fragment>
        <BrowserRouter>
          <AppRoute />
        </BrowserRouter>

      </Fragment>
    );
  }
}

export default App;


//functional component
// import React, { useState } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';

// export const App = () => {
//   //এখানে sate ও setstate এর কাজ করে count, setCount
//   const [count, setCount] = useState(0); // Renamed inccount to setCount for clarity

//   return (
//     <div>
//       <h1>Clicking Me {count}</h1>
//       <button onClick={() => setCount(count + 2)}>Click Me</button>
//     </div>
//   );
// };

// export default App;
